import React from "react";
import { useBetaAccess } from "../lib/beta";
import ComingSoon from "../pages/ComingSoon";

/**
 * Wraps Login / Signup pages so they only render the real form when the
 * beta gate is disabled OR a valid beta code is present in localStorage.
 *
 * While the validation request is in flight we render a tiny full-page
 * loader so the user never momentarily sees the form before the gate
 * decides to hide it.
 */
export default function BetaGate({ children, pageTitle }) {
    const { ready, hasAccess } = useBetaAccess();

    if (!ready) {
        return (
            <div
                data-testid="beta-gate-loading"
                className="min-h-screen flex items-center justify-center bg-alpine-mist text-slate-gray text-sm"
            >
                Loading…
            </div>
        );
    }
    if (!hasAccess) return <ComingSoon pageTitle={pageTitle} />;
    return children;
}
